// Imports: local files.
import {
  GET_EVENTS_START,
  GET_EVENTS_SUCCESS,
  GET_EVENTS_FAILED,
  GET_EVENTS_RESET,
  GET_EVENT_START,
  GET_EVENT_SUCCESS,
  GET_EVENT_FAILED,
  GET_EVENT_RESET,
  CREATE_EVENT_START,
  CREATE_EVENT_SUCCESS,
  CREATE_EVENT_FAILED,
  CREATE_EVENT_RESET,
  UPDATE_EVENT_START,
  UPDATE_EVENT_SUCCESS,
  UPDATE_EVENT_FAILED,
  UPDATE_EVENT_RESET,
  DELETE_EVENT_START,
  DELETE_EVENT_SUCCESS,
  DELETE_EVENT_FAILED,
  DELETE_EVENT_RESET,
} from '../actions';

const initialLoadingState = {
  loading: false,
  success: false,
  data: null,
  error: false,
  errorMessage: null,
};
const initialState = {
  getAll: initialLoadingState,
  getOne: initialLoadingState,
  create: initialLoadingState,
  updateOne: initialLoadingState,
  deleteOne: initialLoadingState,
};

const eventsReducer = (state = initialState, action) => {
  switch (action.type) {
    /**
     * =======================================================================
     * Get All Events
     * =======================================================================
     */
    case GET_EVENTS_START:
      return { ...state, getAll: { ...action.payload } };
    case GET_EVENTS_SUCCESS:
      return { ...state, getAll: { ...action.payload } };
    case GET_EVENTS_FAILED:
      return { ...state, getAll: { ...action.payload } };
    case GET_EVENTS_RESET:
      return { ...state, getAll: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Get One EVENT
     * =======================================================================
     */
    case GET_EVENT_START:
      return { ...state, getOne: { ...action.payload } };
    case GET_EVENT_SUCCESS:
      return { ...state, getOne: { ...action.payload } };
    case GET_EVENT_FAILED:
      return { ...state, getOne: { ...action.payload } };
    case GET_EVENT_RESET:
      return { ...state, getOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Create EVENT
     * =======================================================================
     */
    case CREATE_EVENT_START:
      return { ...state, create: { ...action.payload } };
    case CREATE_EVENT_SUCCESS:
      return { ...state, create: { ...action.payload } };
    case CREATE_EVENT_FAILED:
      return { ...state, create: { ...action.payload } };
    case CREATE_EVENT_RESET:
      return { ...state, create: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Update One EVENT
     * =======================================================================
     */
    case UPDATE_EVENT_START:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_EVENT_SUCCESS:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_EVENT_FAILED:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_EVENT_RESET:
      return { ...state, updateOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Delete One EVENT
     * =======================================================================
     */
    case DELETE_EVENT_START:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_EVENT_SUCCESS:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_EVENT_FAILED:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_EVENT_RESET:
      return { ...state, deleteOne: { ...initialLoadingState } };
    default:
      return state;
  }
};

export default eventsReducer;
